var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58735 2.96875H10.4974C10.7733 2.96875 10.9971 3.19248 10.9971 3.46846V14.462C10.9971 14.738 10.7733 14.9617 10.4974 14.9617H1.50267C1.22669 14.9617 1.00296 14.738 1.00296 14.462V3.46846C1.00296 3.19248 1.22669 2.96875 1.50267 2.96875H4.45697",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9998 11.5133C7.10372 11.5133 7.99862 10.6184 7.99862 9.51445C7.99862 8.41053 7.10372 7.51562 5.9998 7.51562C4.89588 7.51562 4.00098 8.41053 4.00098 9.51445C4.00098 10.6184 4.89588 11.5133 5.9998 11.5133Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00146 13.0108C3.35056 12.5454 3.80323 12.1676 4.32363 11.9074C4.84404 11.6472 5.41787 11.5117 5.9997 11.5117C6.58152 11.5117 7.15536 11.6472 7.67576 11.9074C8.19616 12.1676 8.64883 12.5454 8.99793 13.0108",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88175 1.03516H7.1174L7.11757 4.22548H4.88192L4.88175 1.03516Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8819 5.58594L7.11769 5.58594",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.6fae4e1087c4320162bac5de2f4280ee.svg";
export { ForwardRef as ReactComponent };